// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2izcB","label":"Section_label__1rSp6","contentWrap":"Section_contentWrap__21QB3","footer":"Section_footer__2lBGE","footerInner":"Section_footerInner__2bLXa"};